module.exports = require("npm:process@0.11.3/browser.js");